document.addEventListener("DOMContentLoaded", async function() {
  await ResourceCoordinator.requestVendor("Splide");

  // Initialize Splide carousel
  const splide = new Splide(".section-ugc-gallery .splide", {
    perPage: 4,
    perMove: 4,
    gap: "16px",
    autoWidth: true,
    breakpoints: {
      640: {
        perPage: 1,
        perMove: 1,
        arrows: false,
        gap: "8px",
      },
      912: {
        perPage: 2,
        perMove: 2,
      },
      1200: {
        perPage: 3,
        perMove: 3,
      },
    },
  }).mount();

  const section = document.querySelector(".section-ugc-gallery");
  section.querySelector(".splide-placeholder").remove();

  // Implement lazy loading for videos
  const lazyLoadVideos = () => {
    const videos = section.querySelectorAll("video.lazy");

    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const video = entry.target;

              // Start playing the video when it's in view
              if (video.paused) {
                video.play().catch((error) => {
                  console.warn("Auto-play was prevented:", error);
                });
              }

              // Stop observing once the video is playing
              videoObserver.unobserve(video);
            }
          });
        },
        {
          rootMargin: "100px 0px", // Start loading when video is 100px from viewport
          threshold: 0.1, // Trigger when at least 10% of the video is visible
        }
      );

      videos.forEach((video) => {
        // Pause all videos initially
        video.pause();
        // Observe each video
        videoObserver.observe(video);
      });
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      videos.forEach((video) => {
        video.play().catch((error) => {
          console.warn("Auto-play was prevented:", error);
        });
      });
    }
  };

  // Initialize lazy loading after Splide is mounted
  lazyLoadVideos();

  // Re-initialize lazy loading when Splide moves to ensure videos in view start playing
  splide.on("moved", lazyLoadVideos);
});
